import React, { createContext, useContext } from 'react';
import propTypes from 'prop-types';

import { LocaleProvider } from '../Internationalization';

const CurrentPageContext = createContext(null);

const Page = ({ PageComponent, props: { lang, pageName, ...otherProps } }) => (
  <LocaleProvider locale={lang}>
    <CurrentPageContext.Provider value={pageName}>
      {/* propTypes can't figure out lang on its own, so sadly this way */}
      <PageComponent {...{ ...otherProps, lang }} />
    </CurrentPageContext.Provider>
  </LocaleProvider>
);

Page.propTypes = {
  PageComponent: propTypes.func.isRequired,
  props: propTypes.shape({
    lang: propTypes.string.isRequired,
    pageName: propTypes.string.isRequired,
  }).isRequired,
};

export const useCurrentPage = () => useContext(CurrentPageContext);

export default Page;



// WEBPACK FOOTER //
// ./src/modules/Page/index.js